(function($, $window, $document) {
    'use strict';

    var $pickUpLocationForm     = $('.schedule-pick-up-form'),
        finding                 = false,
        $donationPopup          = $('.donations_popup'),
        $statesButtons          = $('.state-pickup-btn');

    $statesButtons.on('click', function (e) {
        e.preventDefault();

        var search = $(this).attr('data-state');

        if (! search) {
            return;
        }

        searchForPickupLocation(search, true); 
    });

    $pickUpLocationForm.on('submit', function (e) {
        e.preventDefault();

        var search = this.pick_up_by_state.checked ? this.pick_up_state.value : this.pick_up_zip_code.value;

        if (! search) {
            $pickUpLocationForm.find('input[type="search"]').attr('placeholder','Please insert a Zip Code');
            return;
        }

        searchForPickupLocation(search, this.pick_up_by_state.checked); 
    });

    function searchForPickupLocation(search, by_state) {
        findPickUpLocation({
            search: search,
            by_state: by_state ? 'on' : 'off'
        })
        .done(function (response) {
            if (response.found == true) {
                location_found(response.location)
            } else {
                location_not_found()
            }
        })
    }

    function findPickUpLocation(params) {
        if (finding) return;

        finding = true;

        params.action = 'pick_up_location'

        return $.getJSON(ajax_object.ajax_url, params)
        .always(function () { finding = false })
    }

    function location_found(location) {
        var url = location.zipGO2URL + "?zipcode=" + location.zipCODE; 

        $donationPopup.find('.location-not-found').hide();
        $donationPopup.find('.location-found').show();
        var phone = location.zipGO2PHONE;
        if(phone){
            phone = phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
        }
        $donationPopup.find('.schedule-phone').text(phone);
        if(location.zipGO2URL == 0){
            $donationPopup.find('a.schedule-link').hide();
            $donationPopup.find('.popup-description-only-phone').show();
            $donationPopup.find('.popup-description').hide();
            $donationPopup.find('.location-found').addClass('only-phone');
        }else{
            $donationPopup.find('.location-found').removeClass('only-phone');
            $donationPopup.find('.popup-description-only-phone').hide();
            $donationPopup.find('.popup-description').show();
            $donationPopup.find('a.schedule-link').show();
            $donationPopup.find('a.schedule-link').attr('href', url);
        }

        $donationPopup.fadeIn(300);
    }

    function location_not_found() {
        $donationPopup.find('.location-not-found').show();
        $donationPopup.find('.location-found').hide();

        $donationPopup.fadeIn(300);
    }
})(window.jQuery, window, document);
